import { EcleticaTableConfiguration } from "@/core/EcleticaTableConfiguration";
import { useEffect, useState } from "react";

export function useEcleticaTableConfiguration() {
  const [configurationsEcletica, setConfigurationsEcletica] = useState({});

  const isValidEcletica =
    configurationsEcletica?.externalId &&
    configurationsEcletica?.apiUrl &&
    configurationsEcletica?.apiToken

  useEffect(() => {
    const tableConfigurations = EcleticaTableConfiguration.fromStorage();

    setConfigurationsEcletica(tableConfigurations);

    tableConfigurations.addListener(() => {
      const updatedTableConfigurations =
        EcleticaTableConfiguration.fromStorage();
      setConfigurationsEcletica(updatedTableConfigurations);
    });

    return () => tableConfigurations.removeListener();
  }, []);

  const persistConfigurationsEcletica = () => {
    const tableConfigurations = EcleticaTableConfiguration.fromStorage();
    tableConfigurations.update(configurationsEcletica);
  };

  const updateConfigurationsEcletica = (newConfigurations) => {
    if (newConfigurations === null) {
      setConfigurationsEcletica(null);
    } else {
      setConfigurationsEcletica({
        ...configurationsEcletica,
        ...newConfigurations,
      });
    }
  };

  return [
    configurationsEcletica,
    updateConfigurationsEcletica,
    persistConfigurationsEcletica,
    isValidEcletica,
  ];
}
